/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowLineUp(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M205.65674,138.34717A7.99981,7.99981,0,0,1,200,152.00391H136v72a8,8,0,1,1-16,0v-72H56a7.99981,7.99981,0,0,1-5.65674-13.65674l72-72a8,8,0,0,1,11.31348,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" />
    </Svg>
  );
}

export default ArrowLineUp;
